import moment from "moment";
export class BaseService {
  favicon = "BlueSilhouette";
  icon = "GroupOfPeople";

  context = null;

  gemItems = [];
  gemMenuItems = [];
  columns = [];
  listingFooterControls = [];
  sidebarControls = [];
  formAnchor = null;
  bookmark = true;
  inactive = true;
  Terminilogies = {
    employee: {
      singular: "Employee",
      artical: "an",
      plural: "Employees",
    },
    vendor: {
      singular: "Vendor",
      artical: "an",
      plural: "Vendors",
    },
    customer: {
      singular: "Customer",

      artical: "an",

      plural: "Customers",
    },
    client: {
      singular: "Client",

      artical: "an",
      plural: "Clients",
    },
  };

  parse(data) {
    let value = [];
    if (data == "employee") {
      value = this.Terminilogies.employee;
    }

    return value;
  }
  parseStatus(status) {
    let value = "";
    switch (status) {
      case 1:
        value = "Active";
        break;
      default:
        value = "In-active";
        break;
    }
    return value;
  }

  parseType(type) {
    type = type * 1;
    let value = "";
    switch (type) {
      case 1:
        value = "Bank";
        break;
      case 2:
        value = "Account Receivable";
        break;
      case 3:
        value = "Current Asset";
        break;
      case 4:
        value = "Inventory";
        break;
      case 5:
        value = "Fixed Asset";
        break;
      case 6:
        value = "Other Asset";
        break;
      case 7:
        value = "Account Payable";
        break;
      case 8:
        value = "Current Liability";
        break;
      case 9:
        value = "Credit Card";
        break;
      case 10:
        value = "Other Liability";
        break;
      case 11:
        value = "Equity";
        break;
      case 12:
        value = "Revenue";
        break;
      case 13:
        value = "Cost of Sale";
        break;
      case 14:
        value = "Expense";
        break;
      case 15:
        value = "Other Income";
        break;
      case 16:
        value = "Other Expense";
        break;
      default:
        value = "Others";
        break;
    }
    return value;
  }
  parseMonth(type) {
    type = type * 1;
    let value = "";
    switch (type) {
      case 1:
        value = "January";
        break;
      case 2:
        value = "February";
        break;
      case 3:
        value = "March";
        break;
      case 4:
        value = "April";
        break;
      case 5:
        value = "May";
        break;
      case 6:
        value = "June";
        break;
      case 7:
        value = "July";
        break;
      case 8:
        value = "August";
        break;
      case 9:
        value = "September";
        break;
      case 10:
        value = "October";
        break;
      case 11:
        value = "November";
        break;
      case 12:
        value = "December";
        break;

      default:
        value = "Others";
        break;
    }
    return value;
  }
  statuses(type) {
    let status = "";
    switch (type) {
      case 1:
        status = "Approved";
        break;
      case 2:
        status = "Partially Processed";
        break;
      case 3:
        status = "Rejected";
        break;

      default:
        status = "Pending";
        break;
    }
    return status;
  }
  //Date formated
  parseDate(date) {
    return date != null ? moment.unix(date).format("MM/DD/YYYY") : "";
  }
  parseDateMoment(date) {
    return date != null ? moment(date).format("MM/DD/YYYY") : "";
  }
  // constructor
  constructor() {
    //process
    if (this.context) this.t = this.context.i18n.global.t;
    else {
      this.t = () => {};
    }
  }
}
